import { useMemo, Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'Shared/util/custom-hooks';
import { getFooterRows } from './data-table-footer-utils';
import DataTablePaging from './data-table-paging';
import styles from './data-table.css';


const renderSeparatorRow = (customClass) => (
  <tr className={`${styles.separator} ${customClass || ''}`}>
    <td colSpan="100" />
  </tr>
);

const renderFooterRow = (
  columns,
  isInvertedColumn,
  row,
  useSelectableRows,
  useRowInformation,
) => (
  <tr>
    {useSelectableRows && <td className={styles.hiddenFooterColumn} />}
    {columns.map((col, i) => (
      <td
        key={i}
        className={`${isInvertedColumn(col.type) ? styles.alignRight : ''} ${(row[col.key] === '' || col.hiddenMobile) ? styles.hiddenFooterColumn : ''}`}
      >
        {col.formatter && col.footer
          ? col.formatter(row[col.key])
          : row[col.key]}
      </td>
    ))}
    {useRowInformation && <td className={styles.hiddenFooterColumn} />}
  </tr>
);


const DataTableFooter = ({
  loading,
  columns,
  rows,
  isInvertedColumn,
  paging,
  currentPage,
  pageSize,
  handlePaging,
  handleShowAllRows,
  isMobileMode,
  showAllRows,
  useSelectableRows,
  useRowInformation,
}) => {
  const t = useTranslation(x => x.dataTable);
  const groupedRows = useMemo(() => getFooterRows(columns, rows, isMobileMode, t), [columns, rows, isMobileMode]);

  const showPaging = (!loading && paging && rows.length > 0 && rows.length > pageSize);

  if (loading) return null;
  return (
    <>
      {showPaging && (
        <tr className={styles.pagingRow}>
          <td colSpan="100">
            <DataTablePaging
              currentPage={currentPage}
              pageSize={pageSize}
              rowCount={rows.length}
              handlePaging={handlePaging}
              handleShowAllRows={handleShowAllRows}
              isMobileMode={isMobileMode}
              showAllRows={showAllRows}
            />
          </td>
        </tr>
      )}
      {renderSeparatorRow(styles.footerSeparator)}
      {groupedRows.map((row, i) => (
        <Fragment key={i}>
          {renderFooterRow(columns, isInvertedColumn, row, useSelectableRows, useRowInformation)}
          {(groupedRows.length > i + 1) && renderSeparatorRow()}
        </Fragment>
      ))}
    </>
  );
};

DataTableFooter.propTypes = {
  loading: PropTypes.bool,
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  isInvertedColumn: PropTypes.func.isRequired,
  paging: PropTypes.bool.isRequired,
  currentPage: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  handlePaging: PropTypes.func.isRequired,
  handleShowAllRows: PropTypes.func.isRequired,
  isMobileMode: PropTypes.bool.isRequired,
  showAllRows: PropTypes.bool.isRequired,
  useSelectableRows: PropTypes.bool.isRequired,
  useRowInformation: PropTypes.bool.isRequired,
};

export default DataTableFooter;
